import { useState } from 'react';
import { getFontScale, setFontScale, type FontScale } from '@/lib/prefs/fontScale';

const OPTIONS: { value: FontScale; label: string }[] = [
  { value: 'normal', label: 'Normal' },
  { value: 'large', label: 'Large' },
  { value: 'xlarge', label: 'Extra large' },
];

/**
 * FontSizeControl — global UI font-size preference (Feedback A7). Carbon sizes
 * in rem, so this scales the whole app. Persisted + applied immediately.
 */
export const FontSizeControl = () => {
  const [scale, setScale] = useState<FontScale>(getFontScale());

  const choose = (s: FontScale) => {
    setFontScale(s);
    setScale(s);
  };

  return (
    <div
      data-testid="font-size-control"
      role="group"
      aria-label="Font size"
      style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}
    >
      <span style={{ fontWeight: 600, fontSize: '0.875rem' }}>Font size</span>
      {OPTIONS.map((o) => {
        const active = scale === o.value;
        return (
          <button
            key={o.value}
            type="button"
            data-testid={`font-size-${o.value}`}
            aria-pressed={active}
            onClick={() => choose(o.value)}
            style={{
              padding: '0.25rem 0.75rem',
              borderRadius: '0.25rem',
              border: '1px solid var(--cds-border-subtle-01)',
              background: active ? 'var(--cds-interactive-01)' : 'transparent',
              color: active ? 'white' : 'var(--cds-text-primary)',
              cursor: 'pointer',
              fontSize: '0.875rem',
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};
